import React from 'react';
import { ConfidenceRanking } from 'abbot-core';
import img from '../../assets/images/U1-T2-1-6.svg';

const question = 'I know how important nutritious food choices are to my health.';

export default {
  title: 'Confidence Ranking',
  path: '/prepare/confidence',
  content: <ConfidenceRanking question={question} image={img} />
};



// WEBPACK FOOTER //
// ./src/data/prepare/ConfidenceRanking.js